import type { Root, RootContent } from "mdast";
import { segmentTaskBody } from "./segmentTaskBody";

/**
 * Wraps each segment (see segmentTaskBody) in a synthetic `tts-segment` node
 * so it becomes a real component in react-markdown's render tree. Uses the
 * same data.hName/hProperties + .children convention TaskMarkdown.tsx's
 * remarkDropdown already relies on for turning a directive into a component.
 */
export function remarkTtsSegments() {
    return (tree: Root) => {
        const segments = segmentTaskBody(tree);
        tree.children = segments.map((segment) => ({
            type: "ttsSegment",
            children: segment.nodes,
            data: { hName: "tts-segment", hProperties: { index: segment.index } },
        })) as unknown as RootContent[];
    };
}
